import IconChevronDown from '@/assets/icons/icon-chevron-down.svg'
import EditIcon from '@/assets/icons/icon-edit.svg'
import TrashIcon from '@/assets/icons/icon-trash.svg'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { classNames } from '@/utils/helpers'

import { useSalesEditor } from './hooks/use-sales-editor'
import { useSalesTemplateActions } from './useSalesTemplateActions'

export const SalesEditorActionsDropdown = () => {
  const { activeTemplate, templates, saveChanges } = useSalesEditor()
  const { onCopy, onCreate, onEdit, onDelete, onSelectTemplate } =
    useSalesTemplateActions()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="bg-card dark:bg-secondary-600 fixed bottom-4 left-1/2 -translate-x-1/2 rounded-md border px-4 py-3">
        <div className="flex items-center gap-2.5">
          <span className="text-sm">
            {activeTemplate ? activeTemplate.name : 'No template'}
          </span>
          <IconChevronDown className="text-title h-4 w-4 flex-shrink-0" />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="min-w-[208px] p-2"
        align="start"
      >
        <DropdownMenuGroup>
          <DropdownMenuItem
            className="px-3 font-medium"
            onClick={() => onSelectTemplate()}
          >
            None
          </DropdownMenuItem>
          {templates.map((template) => (
            <DropdownMenuItem
              key={template.id}
              className={classNames(
                'flex items-center justify-between px-3',
                activeTemplate?.id === template.id &&
                  'bg-primary-100 hover:bg-primary-100 dark:bg-primary-900',
              )}
              onClick={() => onSelectTemplate(template.id)}
            >
              <span className="font-medium">{template.name}</span>
              <div className="flex items-center gap-4">
                <Button
                  size="icon"
                  variant="ghost"
                  className="h-[18px] w-[18px]"
                  onClick={onEdit(template)}
                >
                  <EditIcon />
                </Button>
                <Button
                  size="icon"
                  variant="ghost"
                  className="h-[18px] w-[18px]"
                  onClick={onDelete(template)}
                >
                  <TrashIcon className="text-danger-default" />
                </Button>
              </div>
            </DropdownMenuItem>
          ))}
        </DropdownMenuGroup>
        <div className="my-1 border-b" />
        <DropdownMenuGroup>
          {activeTemplate && (
            <>
              <DropdownMenuItem
                className="flex items-center gap-2 px-3 font-medium"
                onClick={saveChanges}
              >
                Save Changes
              </DropdownMenuItem>
              <DropdownMenuItem
                className="flex items-center gap-2 px-3 font-medium"
                onClick={onCopy}
              >
                Save as New Template
              </DropdownMenuItem>
            </>
          )}
          <DropdownMenuItem
            className="flex items-center gap-2 px-3 font-medium"
            onClick={onCreate}
          >
            Create new template
          </DropdownMenuItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
